import { defineComponent as _defineComponent } from 'vue'
import { useRoute } from '@/composables/router';
import { User } from '@/models/user';
import { usersService } from '@/services/users.service';
import { computed } from 'vue';
import * as permissionUtils from '@/utils/permissionUtils';
import InformationMenu from '@/components/header/InformationMenu.vue';
import NotificationsMenu from '@/components/header/NotificationsMenu.vue';
import SettingsMenu from '@/components/header/SettingsMenu.vue';
import CareConsoleSettingsMenu from '@/components/header/CareConsoleSettingsMenu.vue';
import UserMenu from '@/components/header/UserMenu.vue';
import { useI18n } from '@/composables/i18n';
import { Routes } from '@/router/routes';


/** @deprecated THIS COMPONENT IS FROZEN
 * Header used on all pages showing the page title and several menus (user,
 * settings...).
 */
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Header',
  emits: ['toggle:sidebar', 'toggle:beta'],
  setup(__props, { emit }) {



const route = useRoute();
const i18n = useI18n();

const breadcrumb = computed(() => {
  if (user.value.isTechnologyUser) {
    return i18n.t(`report.technology`).toString();
  }

  if (user.value.isServiceUserType) {
    if (route.value.name === Routes.EServiceCenterEquipmentView) {
      return i18n.t('e_service_center.breadcrumb.index').toString();
    }

    return i18n
      .t(`e_service_center.breadcrumb.${route.value.name!}`)
      .toString();
  }

  if (route.value.name!.includes('-')) {
    if (
      route.value.name!.includes('kpi') ||
      route.value.name!.includes('control')
    ) {
      return i18n.t(`report.${route.value.name!}`).toString();
    }
    return i18n.t(`report.${route.value.name!.split('-')[1]}`).toString();
  }

  return i18n.t(`report.${route.value.name}`).toString();
});

const user = computed((): User => usersService.store.current());

const showInfoButton = computed(
  (): boolean =>
    !(showTechnologyConsole.value || showEServiceCenterSettingsMenu.value),
);

const showSettings = computed(
  (): boolean => !(user.value.isTechnologyUser || user.value.isServiceUserType),
);

const showEServiceCenterSettingsMenu = computed(
  (): boolean =>
    isEServiceCenter.value &&
    permissionUtils.canAccessCareConsoleSettingsMenu(),
);

const isEServiceCenter = computed((): boolean =>
  route.value.path.includes('e-service-center'),
);

const showTechnologyConsole = computed(
  (): boolean =>
    isTechnologyConsole.value && permissionUtils.canAccessTechnologyConsole(),
);

const isTechnologyConsole = computed((): boolean =>
  route.value.path.includes('technology-console'),
);

return { __sfc: true,emit, route, i18n, breadcrumb, user, showInfoButton, showSettings, showEServiceCenterSettingsMenu, isEServiceCenter, showTechnologyConsole, isTechnologyConsole, InformationMenu, NotificationsMenu, SettingsMenu, CareConsoleSettingsMenu, UserMenu }
}

})